/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channeltitle1Inputs */

const en_channeltitle1 = /** @type {(inputs: Channeltitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Channel`)
};

const de_channeltitle1 = /** @type {(inputs: Channeltitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanal`)
};

/**
* | output |
* | --- |
* | "Channel" |
*
* @param {Channeltitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channeltitle1 = /** @type {((inputs?: Channeltitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channeltitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channeltitle1(inputs)
	return de_channeltitle1(inputs)
});
export { channeltitle1 as "channelTitle" }